<template>
  <div>
    <div class="menu-title">标签管理</div>
    <div class="menu-content">
      <el-form :inline="true" :model="query" size="small">
        <el-form-item label="标签名称：">
          <el-input v-model="query.LIKES_name" placeholder="请输入标签名称" clearable @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item>
          <el-button type="success" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
      <div style="margin-bottom: 20px">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openCreate">添加</el-button>
      </div>
      <div class="table-list">
        <el-table v-loading="loading" :data="result.records" style="width: 100%">
          <el-table-column type="index" label="序号" width="100" />
          <el-table-column prop="name" label="标签名称" />
          <el-table-column prop="sort" label="排序" width="100" />
          <el-table-column prop="createTime" label="创建时间" width="180" />
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-edit" size="small" @click="openEdit(scope.row)">编辑</el-button>
              <el-button type="text" icon="el-icon-delete" size="small" @click="removeRow(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-box">
        <el-pagination
          background
          :current-page="query.pageNo"
          :page-size="query.pageSize"
          :page-sizes="[10, 20, 30, 40, 50]"
          :total="result.total"
          layout="total, sizes, prev, pager, next"
          @current-change="changePage"
          @size-change="changeSize"
        />
      </div>
    </div>
    <el-dialog :title="form.id == null ? '添加标签' : '编辑标签'" :visible.sync="dialogVisible" :close-on-click-modal="false" width="480px" custom-class="memory-tag-dialog">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="标签名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入标签名称" maxlength="100" show-word-limit />
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :precision="0" :step="1" controls-position="right" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="save">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request';

const api = '/core/memory-circle-tag';

export default {
  name: 'MemoryCircleTagManage',
  data() {
    return {
      query: { pageNo: 1, pageSize: 10, LIKES_name: '', ASCI_sort: 1 },
      result: { records: [], total: 0 },
      form: { id: null, name: '', sort: 0 },
      rules: {
        name: [{ required: true, whitespace: true, message: '请输入标签名称', trigger: 'blur' }],
        sort: [{ required: true, type: 'integer', min: 0, message: '排序必须为非负整数', trigger: 'change' }]
      },
      dialogVisible: false,
      loading: false,
      saving: false
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      return request({ url: `${api}/query_pages`, method: 'post', data: this.query })
        .then(result => { this.result = result; })
        .finally(() => { this.loading = false; });
    },
    search() {
      this.query.pageNo = 1;
      this.load();
    },
    changePage(page) {
      this.query.pageNo = page;
      this.load();
    },
    changeSize(size) {
      this.query.pageSize = size;
      this.query.pageNo = 1;
      this.load();
    },
    openCreate() {
      this.form = { id: null, name: '', sort: 0 };
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.form.clearValidate());
    },
    openEdit(row) {
      this.form = { id: row.id, name: row.name || '', sort: row.sort == null ? 0 : row.sort };
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.form.clearValidate());
    },
    removeRow(row) {
      this.$confirm('确定删除该标签吗？', '提示', { type: 'warning' })
        .then(() => request({ url: `${api}/remove/${row.id}`, method: 'post' }))
        .then(() => {
          this.$message.success('删除成功');
          if (this.result.records.length === 1 && this.query.pageNo > 1) this.query.pageNo -= 1;
          this.load();
        })
        .catch(() => {});
    },
    save() {
      this.$refs.form.validate(valid => {
        if (!valid || this.saving) return;
        const editing = this.form.id != null;
        this.saving = true;
        request({
          url: `${api}/${editing ? 'modify' : 'create'}`,
          method: 'post',
          data: { ...(editing ? { id: this.form.id } : {}), name: this.form.name.trim(), sort: this.form.sort }
        }).then(() => {
          this.$message.success(editing ? '编辑成功' : '添加成功');
          this.dialogVisible = false;
          this.load();
        }).finally(() => { this.saving = false; });
      });
    }
  }
};
</script>

<style lang="scss">
.memory-tag-dialog { max-width: calc(100vw - 32px); }
</style>
